import * as types from "./../action-types";
import axios from "axios";
import JWTDecode from "jwt-decode";
import AuthToken from "@/helpers/AuthToken";

const cleanUpStore = (commit) => {
  commit("db/shared/resetState", null, { root: true });
  commit("db/account/resetState", null, { root: true });
  commit("db/devices/resetState", null, { root: true });
  commit("db/requests/resetState", null, { root: true });
  commit("db/account/location/resetState", null, { root: true });
};
const rejectBadToken = (msg) =>
  new Promise((_, reject) => {
    reject(new Error(msg));
  });

async function updateAdminUser({ commit, rootGetters }, data) {
  let user = rootGetters["auth/user"];
  let payload = { admin_user: data };
  const response = await axios.put(`admin_users/${user.id}`, payload);
  commit(types.SET_USER, response.data);
  return response.data;
}

async function loadAdminUser({ commit, rootGetters }, data) {
  const response = await axios.get(`admin_users/profile`);
  return response.data;
}

async function logIn({ commit }, authorizationCode) {
  try {
    let payload = JWTDecode(authorizationCode);
    let email = payload["email"];
    if (!email)
      return rejectBadToken("Missing field in authorization code: Email");

    const response = await axios.post("/v2/auth/token", {
      code: authorizationCode,
      grant_type: "authorization_code",
      email,
    });

    const accessToken = response.headers["access-token"];
    let firstLogin = true;
    let result = AuthToken.init(firstLogin).save(accessToken);
    if (result.error) return rejectBadToken(result.error);
  } catch (error) {
    commit(types.LOGIN.ERROR);
    throw error.response;
  }
}

const logOut = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit(types.LOGOUT.SUCCESS);
    cleanUpStore(commit);
    resolve();
  });
};

export default {
  logIn,
  logOut,
  updateAdminUser,
  loadAdminUser,
};
